// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9910 ? "a4634e51" : chunkId) + "." + {"5870":"a9725766eba38d24","9910":"39ad6d54a660fc38"}[chunkId] + ".js";
};